export const areCortexPermissionsEnabled = () =>
  isCortexEnabled() &&
  import.meta.env.VITE_CORTEX_PERMISSIONS_ENABLED === 'true';

export const isCortexEnabled = () =>
  import.meta.env.VITE_CORTEX_ENABLED === 'true';

export const isNavUpdateEnabled =
  import.meta.env.VITE_NAV_UPDATE_ENABLED === 'true';

export const isTimezoneFlagEnabled =
  import.meta.env.VITE_TIMEZONE_FLAG_ENABLED === 'true';

export const isProduction = import.meta.env.PROD;

export const isStagingEnv = import.meta.env.VITE_TARGET_ENV === 'staging';

export const isDemoEnv = import.meta.env.VITE_TARGET_ENV === 'demo';

export const isProductionEnv = import.meta.env.VITE_TARGET_ENV === 'production';

export const isLocalDevelopment = import.meta.env.DEV;

export const getPendoVisitorIdPrefix = (): string => {
  if (isProductionEnv) return '';
  if (isStagingEnv) return 'staging-';
  if (isDemoEnv) return 'demo-';

  return '';
};

// the variable below verifies if the given environment is the one used for unit/integration tests
export const isTestingEnv = process.env.NODE_ENV === 'test';

export const MUILicenseKey = import.meta.env.VITE_MUI_LICENSE_KEY ?? '';

function getSocketSubdomain() {
  if (isProduction && !isStagingEnv && !isDemoEnv) {
    return 'socket';
  }
  if (isDemoEnv) {
    return 'demo';
  }
  return 'socketdev';
}

export const SOCKET_URL = `wss://${getSocketSubdomain()}.thecoursekey.com/portal`;

export const BUILD_ID = import.meta.env.VITE_BUILD_ID ?? '';

export const CARDKNOX_FIELDS_KEY = import.meta.env.VITE_CARDKNOX_FIELDS_KEY;

export const CARDKNOX_SOFTWARE_NAME = import.meta.env
  .VITE_CARDKNOX_SOFTWARE_NAME;
export const CARDKNOX_SOFTWARE_VERSION = import.meta.env
  .VITE_CARDKNOX_SOFTWARE_VERSION;
export const CARDKNOX_LIB_VERSION = import.meta.env.VITE_CARDKNOX_LIB_VERSION;

export const STRIPE_PUBLISHABLE_KEY = import.meta.env
  .VITE_STRIPE_PUBLISHABLE_KEY;
export const STRIPE_DASHBOARD_URL = 'https://dashboard.stripe.com';

// Separate Stripe account for platform subscriptions — NOT the Connect/payments key above.
export const STRIPE_SUBSCRIPTION_PUBLISHABLE_KEY = import.meta.env
  .VITE_STRIPE_SUBSCRIPTION_PUBLISHABLE_KEY;

export const IXOPAY_GATEWAY_URL =
  import.meta.env.VITE_IXOPAY_GATEWAY_URL ?? 'https://gateway.ixopay.com';

function getApplePayMerchantId() {
  if (isProductionEnv && !isStagingEnv && !isDemoEnv) {
    return '';
  }
  return '.staging';
}

export const APPLE_PAY_MERCHANT_ID = `merchant.com.portico${getApplePayMerchantId()}`;

// IxoPay's gateway name as registered with Google Pay — fixed identifier, not environment-specific.
export const GOOGLE_PAY_GATEWAY = 'ixopay';

// Google Pay Business Console merchant ID (format: BCR2DN...).
export const GOOGLE_PAY_MERCHANT_ID =
  import.meta.env.VITE_GOOGLE_PAY_MERCHANT_ID ?? '';

export function getBaseApiUrl() {
  if (isProduction && !isStagingEnv && !isDemoEnv && !isLocalDevelopment) {
    return 'https://portal.thecoursekey.com';
  }
  if (isStagingEnv) {
    return 'https://staging.thecoursekey.com';
  }
  if (isDemoEnv) {
    return 'https://demo.thecoursekey.com';
  }
  if (isLocalDevelopment) {
    return 'https://local.thecoursekey.com:9001';
  }
  return '';
}
